import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';



export const Header = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
   
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
        <Nav.Link  href="/"><h5>Totle<span className='chris'>Soft</span></h5></Nav.Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
              <Nav.Link href="/printing" className={activeLink === 'printing' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('printing')}>Services</Nav.Link>
              <Nav.Link href="/academy" className={activeLink === 'academy' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('academy')}>Academy</Nav.Link>
              <Nav.Link href="/blog" className={activeLink === 'blog' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('blog')}>Blog</Nav.Link>
              <Nav.Link href="/privacy-policy" className={activeLink === 'privacy-policy' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('privacy-policy')}>Privacy Policy</Nav.Link>
              </Nav>
            <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/totlesoft/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.facebook.com/totlesoftmedia/"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://www.instagram.com/totlesoft/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            </span>
            
          </Navbar.Collapse>
        </Container>
      </Navbar>
   
  )
}
